export function enrichProvinceBounds(data) {
  return data.provinceList.map((province) => {
    let latMin = Infinity;
    let latMax = -Infinity;
    let lngMin = Infinity;
    let lngMax = -Infinity;

    for (const city of province.cityList) {
      latMin = Math.min(latMin, city.latMin);
      latMax = Math.max(latMax, city.latMax);
      lngMin = Math.min(lngMin, city.lngMin);
      lngMax = Math.max(lngMax, city.lngMax);
    }

    return {
      ...province,
      latMin,
      latMax,
      lngMin,
      lngMax,
    };
  });
}

function inRange(lat, lng, range, EPS = 0) {
  return (
    lat >= range.latMin - EPS &&
    lat <= range.latMax + EPS &&
    lng >= range.lngMin - EPS &&
    lng <= range.lngMax + EPS
  );
}

export function findLocation(lat, lng, provinces, options = {}) {
  const { epsilon = 0 } = options;

  for (const province of provinces) {
    // ✅ 第一步：先判断省
    if (!inRange(lat, lng, province, epsilon)) continue;

    // ✅ 第二步：再判断城市
    for (const city of province.cityList) {
      if (inRange(lat, lng, city, epsilon)) {
        return {
          provinceName: province.provinceName,
          provinceCode: province.provinceCode,
          cityName: city.cityName,
          cityCode: city.cityCode,
        };
      }
    }

    // 落在省但没命中城市（极少）
    return {
      provinceName: province.provinceName,
      provinceCode: province.provinceCode,
      cityName: null,
      cityCode: null,
    };
  }

  return null;
}
export function findLocationSafe(lat, lng, provinces) {
  const _lat = Number(lat);
  const _lng = Number(lng);

  if (!isFinite(_lat) || !isFinite(_lng)) {
    return null;
  }

  return findLocation(_lat, _lng, provinces);
}
